import { Button } from '@cocoonspace/ui/components/button'
import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { Input } from '@cocoonspace/ui/components/input'
import { Textarea } from '@cocoonspace/ui/components/textarea'
import { useLingui } from '@lingui/react/macro'
import { ArrowLeftIcon } from 'lucide-react'

import { useAnswerCard } from './provider'

export const Validation = () => {
	const { t } = useLingui()
	const { setStep } = useAnswerCard()

	return (
		<div className='col-span-4 flex flex-1 flex-col p-4 md:min-w-[400px]'>
			<div className='grid grid-cols-2 gap-4'>
				<FormControlledInput
					label={`${t`Prénom`} *`}
					name='additionalInfos.first_name'
					render={({ field }) => <Input {...field} />}
				/>

				<FormControlledInput
					label={`${t`Nom`} *`}
					name='additionalInfos.last_name'
					render={({ field }) => <Input {...field} />}
				/>
			</div>

			<FormControlledInput
				label={`${t`Email`} *`}
				name='email'
				render={({ field }) => <Input {...field} />}
			/>

			<FormControlledInput
				label={t`Commentaire`}
				name='additionalInfos.comment'
				render={({ field }) => <Textarea {...field} />}
			/>

			<div className='flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-4'>
				<Button
					type='submit'
					// size='sm'
					className='md:order-1'
				>
					{t`Valider`}
				</Button>

				<Button
					variant='link'
					size='sm'
					className='md:order-0'
					onClick={() => setStep('dateTime')}
				>
					<ArrowLeftIcon />
					{t`Retour`}
				</Button>
			</div>
		</div>
	)
}
